var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryPlane = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.852 32.202 28.18 17.54v-6.5c0-1.031-.229-2.062-.688-3.035l-.343-.63A2.354 2.354 0 0 0 24.999 6c-.917 0-1.748.515-2.149 1.346l-.372.716a7.19 7.19 0 0 0-.66 3.007v6.5L7.146 32.231A3.939 3.939 0 0 0 6 35.037v1.861c0 .287.172.544.401.688.258.143.573.143.803-.03l14.93-9.564c.143 2.406.344 4.382.601 6.816l.258 2.491-5.559 3.666a.766.766 0 0 0-.344.658v1.575c0 .23.115.458.287.63.2.143.43.2.659.143l6.963-1.546 6.964 1.546c.057 0 .115.029.172.029a.779.779 0 0 0 .487-.172c.2-.143.287-.372.287-.63v-1.575a.84.84 0 0 0-.344-.658l-5.56-3.666.258-2.491c.258-2.434.43-4.439.602-6.816l14.93 9.565a.742.742 0 0 0 .802.029.771.771 0 0 0 .402-.688v-1.861c.028-1.117-.402-2.09-1.147-2.835z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-plane.6c6f8f65ff691f555f6d43e8fd37c899.svg";